<template>
  <div class="page">
    <div class="head">
      <el-image src="https://file.aavisa.com/browser-upload-file/9404940d-37dc-4e63-98e8-7ab1511df0d4.jpg"
        style="width: 100%;height: 100%;" fit="fill">
      </el-image>
    </div>

    <div class="main">
      <div class="main_left">

        <div class="search">
          <el-autocomplete v-model="state" :fetch-suggestions="querySearchAsync" placeholder="国家搜索"
            @select="handleSelect">
            <img style="" slot="suffix"
              src="https://file.aavisa.com/browser-upload-file/d0c89cb8-200e-481b-82c7-631bfdac9b03.jpg">
          </el-autocomplete>
        </div>

        <div class="main_County">
          <span>{{County}}</span>
          <el-divider direction="vertical"></el-divider>
          <el-image class="el-image"
            src="https://file.aavisa.com/browser-upload-file/826b6d59-1a31-4263-be30-f2f6055eb5ea.jpg">
          </el-image>
          <span>{{Detail && Detail.entity ? (Detail.entity.AreaRule || '居住地') : '居住地'}}-</span>
          <el-popover popper-class="el-popovers" placement="bottom-end" trigger="hover" :visible-arrow="false">
            <div style="width:19rem;">
              <span>热门</span>
              <div class="province_box">
                <el-row :gutter="8">
                  <el-col :span="4.8">
                    <div class="grid-content bg-purple province_item" @click="changeProvince('北京')">
                      北京
                    </div>
                  </el-col>
                  <el-col :span="4.8">
                    <div class="grid-content bg-purple province_item" @click="changeProvince('上海')">
                      上海
                    </div>
                  </el-col>
                  <el-col :span="4.8">
                    <div class="grid-content bg-purple province_item" @click="changeProvince('广东')">
                      广东
                    </div>
                  </el-col>
                  <el-col :span="4.8">
                    <div class="grid-content bg-purple province_item" @click="changeProvince('江苏')">
                      江苏
                    </div>
                  </el-col>
                  <el-col :span="4.8">
                    <div class="grid-content bg-purple province_item" @click="changeProvince('四川')">
                      四川
                    </div>
                  </el-col>

                </el-row>
              </div>
              <span>全部</span>
              <div class="province_box">
                <el-row :gutter="8">
                  <el-col :span="4.8" v-for="(item,index) in provinceList" :key="index">
                    <div class="grid-content bg-purple province_item" @click="changeProvince(item)">
                      {{item}}
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
            <template slot="reference">
              <div>
                <span>
                  {{province || '定位中'}}
                </span>
                <i class="el-icon-caret-bottom"></i>
              </div>
            </template>

          </el-popover>
        </div>




        <div class="main_list">
          <el-tabs v-model="activeName" @tab-click="handleClick" style="text-align: left">

            <el-tab-pane :label="item" :name="item" v-for="(item,index) in tab" :key="item">
              <div v-if="visaList.length > 0" v-loading="loading2">
                <div class="list" :class="visaIndex == _index_ ? 'list_active' : ''"
                  v-for="(_item_,_index_) in visaList" :key="_item_.Id" @click="changeVisaList(_index_)">
                  <div class="list_title">
                    <span
                      :class="_item_.color">{{_item_.Reason.length > 2 ? _item_.Reason[0]+_item_.Reason[1]+'签': _item_.Reason+'签'}}</span>
                    <span>{{_item_.VisaTitle}}</span>
                  </div>

                  <div class="list_tips">
                    <span><i class="el-icon-time"></i>{{_item_.WorkDay}}</span>
                    <span>有效期{{_item_.StayDay}}</span>
                    <span>￥{{_item_.Price1}}</span>
                  </div>
                </div>
              </div>

              <div v-else>
                <el-empty description="暂无产品"></el-empty>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <div v-if="Detail && Detail.entity" class="main_right" v-loading="loading">
        <div class="basic_info">
          <div class="main_title">
            {{Detail.entity.VisaTitle}}
          </div>
          <div class="main_tabs">
            <span :class="item.color" v-for="(item,index) in Detail.entity.Reason" :key="index">{{item.name}}签</span>
          </div>
          <div class="main_term">
            <div class="main_term_item">
              <div class="">
                有效期
              </div>
              <div class="">
                {{Detail.entity.LimitTime}}
              </div>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="main_term_item">
              <div class="">
                停留时间
              </div>
              <div class="">
                {{Detail.entity.StayDay}}
              </div>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="main_term_item">
              <div class="">
                入境次数
              </div>
              <div class="">
                {{Detail.entity.EnterCount}}
              </div>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="main_term_item">
              <div class="">
                办理时长
              </div>
              <div class="">
                {{Detail.entity.WorkDay}}
              </div>
            </div>

            <!-- <el-divider direction="vertical"></el-divider> -->

            <div class="main_term_item">
              <div class="main_term_price">
                <span>￥{{Detail.entity.Price1}}</span>
                <span style="margin-right: 0.125rem;">明细</span>
              </div>
            </div>
          </div>

          <div class="main_detail">
            <div class="main_term_item">
              <div class="">
                受理领区
              </div>
              <div class="">
                {{Detail.entity.AreasName}}，{{Detail.entity.AreaRule}}：{{Detail.entity.Province}}
              </div>
            </div>
            <el-button type="primary" @click="goLink(Detail.entity.Id)">立即办理</el-button>
          </div>

          <div class="main_tips">
            <div class="main_tips_title">
              注意事项
            </div>
            <div class="main_tips_box" v-html="delHtmlTab(Detail.entity.NoticeDesc)">

            </div>
          </div>
        </div>


        <div class="file_Download" v-if="dc.length > 0">
          <div class="file_tiele">常用文件下载</div>
          <div style="clear:both;"></div>

          <div class="file_item">
            <div class="item" v-for="(item,index) in dc" :key="index" @click="downLoad('dc',item.FilePath)">
              {{item.FileName}}
            </div>
          </div>
        </div>

        <div class="information">
          <div class="info_tiele">所需资料</div>
          <div class="info_download">
            <el-button type="primary" plain :loading="downLoadPDF" @click="downLoad('PDF',Detail.entity.Id)">下载PDF资料
            </el-button>
            <el-button type="primary" :loading="downLoadWORD" @click="downLoad('WORD',Detail.entity.Id)">
              下载WORD资料
            </el-button>
          </div>
          <div style="clear:both;"></div>

          <el-tabs v-model="infoName" @tab-click="infoClick">
            <el-tab-pane v-for="(item,index) in informationTab" v-if="information[item.value].length > 0" :key="index"
              :label="item.name" :name="item.value">
              <div class="info_main" v-for="(item,index) in information[infoName]" :key="index">
                <div>
                  <div class="info_main_title">
                    <div class="">
                      {{item.DocName}}
                    </div>

                  </div>

                  <div class="info_main_box" v-for="(_item_,_index_) in item.vds">
                    <div class="info_main_left">
                      {{_item_.ds.DocName}}
                      <span class="IsNeed" v-if="_item_.IsNeed">
                        *
                      </span>
                    </div>

                    <div class="info_main_right" v-html="delHtmlTab(_item_.ds.Extend)"></div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>

        </div>

        <!-- 				<div class="knowledge">
					<div class="knowledge_tiele">签证知识流程树</div>
					<div style="clear:both;"></div>
					
				</div> -->
      </div>
      <div v-else class="main_right">
        <el-empty description="暂无数据"></el-empty>
      </div>
    </div>

    <login ref="login"></login>
  </div>
</template>

<script>
  import login from '../../components/login/login.vue'
  export default {
    components: {
      login
    },
    data() {
      return {
        dialogVisible: false,
        CountryId: '',
        visaList: [],
        visaIndex: 0,
        state: '', // 搜索框
        timeOut: null,
        activeName: '全部',
        tab: ['全部'],
        Detail: {
          entity: {}
        }, // 产品详情
        loading: false,
        loading2: false,
        infoName: '',
        information: {
          alllist: [], // 所有人群
          worklist: [], // 在职 
          finishlist: [], // 退休
          studentlist: [], // 在读学生
          student2list: [], // 18岁以下学生
          childlist: [], // 儿童
          freelist: [], // 自由职业
        },
        informationTab: [{
          name: '所有人群',
          value: 'alllist',
        }, {
          name: '在职',
          value: 'worklist',
        }, {
          name: '退休',
          value: 'finishlist',
        }, {
          name: '在读学生',
          value: 'studentlist',
        }, {
          name: '18岁以下学生',
          value: 'student2list',
        }, {
          name: '儿童',
          value: 'childlist',
        }, {
          name: '自由职业',
          value: 'freelist',
        }],

        downLoadPDF: false, // pdf按钮加载
        downLoadWORD: false, // word按钮加载
        dc: [], // 常用文件下载
        http: 'https://www.aavisa.com',

        mapKey: 'UV0DBZ-T5I36-FNRS2-EKUY2-LE6V2-QHBLD', // 腾讯地图的key
        typeName: '',
        areaRule: '',
        province: '全部', // 常驻地
        provinceList: ['全部', '北京', '上海', '广东', '四川', '天津', '河北', '山西', '内蒙古', '辽宁', '吉林', '黑龙江', '江苏', '浙江', '安徽',
          '福建', '江西', '山东', '河南',
          '湖北', '湖南', '广西', '海南', '重庆', '贵州', '云南', '西藏', '陕西', '甘肃', '青海', '宁夏', '新疆', '台湾', '香港', '澳门'
        ],

        County: '', // 国家
      }
    },
    created() {
      let {
        id,
        County,
        detail = ''
      } = this.$route.query
      this.CountryId = id
      this.County = County
      this.GetProduct(detail)
      var PcMemberId = cookie.get('PcMemberId')
      if (!PcMemberId) {
        cookie.set('isLogin', false)
      }

      // // 1初始化腾讯地图
      // this.geolocation = new window.qq.maps.Geolocation(this.mapKey, 'myapp')
      // // 2开始定位
      // this.getMyLocation()
    },

    watch: {
      $route(to, from) {
        let {
          id,
          County,
        } = this.$route.query;
        this.CountryId = id;
        this.County = County;
        this.visaIndex = 0;
        this.GetProduct()
      }
    },
    methods: {

      delHtmlTab(str) {
        if (/<p><br><\/p>/g.test(str)) {
          str = str.replace(/<p><br><\/p>/g, '')
        }
        if (/<p><\/p>/g.test(str)) {
          str = str.replace(/<p><\/p>/g, '')
        }
        return str
      },

      handleClose() {

      },

      changeProvince(name) {
        this.province = name;
        this.visaIndex = 0;
        this.GetProduct()
        this.dialogVisible = false;
      },

      goLink(id) {
        if (!this.$refs.login.checkLogin()) return false;
        this.$router.push(`/create?id=${id}`)
      },
      // 所需资料tab栏点击事件
      infoClick() {},

      // 左侧tab栏点击事件
      handleClick(e) {
        // console.log(e.name)
        this.typeName = e.name
        this.GetProduct()
        this.visaIndex = 0
        //发送请求
      },

      // 搜索框事件
      querySearchAsync(queryString, cb) {
        clearTimeout(this.timeOut)
        this.timeOut = setTimeout(() => {
          if (queryString) {
            this.$api.SeachCountry({
              keys: queryString
            }).then(res => {
              let {
                data,
                status
              } = res.data
              if (status == 200 && data.data.length > 0) {
                let list = []
                list = data.data.map((item, index) => {
                  return {
                    value: item.zh_name,
                    id: item.id
                  }
                })
                cb(list)
              } else {
                cb()
              }
            })
          } else {
            cb()
          }
        }, 100)

      },

      // 搜索框点击
      handleSelect(item) {
        this.CountryId = item.id
        this.GetProduct()
        this.visaIndex = 0
        this.County = item.value
      },

      // 获取签证列表
      GetProduct(Id = '') {
        this.loading = true
        this.loading2 = true
        let {
          CountryId,
          typeName,
          province,
        } = this
        this.$api.GetProduct({
          CountryId,
          typeName: typeName == '全部' ? '' : typeName,
          ShengName: province == '全部' ? '' : province,
        }).then(res => {
          let {
            data,
            result,
            message
          } = res.data;
          
          if (message && message.indexOf("暂无产品") > -1) {
            this.loading2 = false
            this.visaList = []
            this.Detail = null
            this.dc = []
            this.infoName = ''
            for (let key in this.information) {
              this.information[key] = []
            }
            this.loading = false
            return
          }

          if (result && data.data.DataList != null) {

            let reg = new RegExp(",", "g");
            let visaList = data.data.DataList.map((item, index) => {
              var str = item.Reason.replace(reg, "");
              item.Reason = str
              switch (str) {
                case '旅游':
                  item.color = 'blue'
                  break
                case '商务':
                  item.color = 'green'
                  break
                case '探访':
                  item.color = 'cyan'
                  break
                case '留学':
                  item.color = 'pink'
                  break
                case '工作':
                  item.color = 'orange'
                  break
                default:
                  item.color = 'blue'
                  break
              }
              return item
            })
            this.loading2 = false
            this.visaList = visaList
            this.tab = ['全部', ...data.tab]
            this.areaRule = data.areaRule
            if (visaList.length === 0) {
              this.Detail = null
              this.dc = []
              this.infoName = ''
              for (let key in this.information) {
                this.information[key] = []
              }
              this.loading = false
              return
            }

            if (Id) {
              for (let i in visaList) {
                if (Id == visaList[i].Id) {
                  this.visaIndex = i
                }
              }
            }
            if (this.visaIndex < 0 || this.visaIndex >= visaList.length) {
              this.visaIndex = 0
            }
            this.GetDetail(visaList[this.visaIndex].Id)

          } else {
            // debugger
            this.loading2 = false
            this.visaList = []
            this.Detail = null
            this.dc = []
            this.infoName = ''
            for (let key in this.information) {
              this.information[key] = []
            }
            this.loading = false
          }
        }).catch(err => {
          this.loading2 = false
          this.visaList = []
          this.Detail = null
          this.dc = []
          this.infoName = ''
          for (let key in this.information) {
            this.information[key] = []
          }
          this.loading = false
          // this.$message({ message: '加载失败，请稍后重试', type: 'error' })
        })
      },

      //定位
      // getMyLocation() {
      //   this.geolocation.getIpLocation(this.showPosition, this.errorPosition) //开启定位
      // },
      // // 定位成功时的函数
      // showPosition(position) {
      //   this.province = position.province
      //   console.log(position.province)
      //   this.GetProduct()
      // },
      // //定时失败时的函数
      // errorPosition() {
      //   this.province = '全部'
      //   // this.GetProduct()
      //   console.log('请检查是否开启了定位')
      // },

      // 获取订单详情
      GetDetail(visaId) {
        if (!visaId) {
          this.Detail = null
          this.dc = []
          this.infoName = ''
          for (let key in this.information) {
            this.information[key] = []
          }
          this.loading = false
          return
        }
        this.dc = []
        this.loading = true
        this.$api.GetDetail({
          visaId
        }).then(res => {
          let {
            data,
            result
          } = res.data
          if (result && data != null && data.entity != null) {
            let reg = new RegExp(",", "g");
            var str = data.entity.Reason.replace(reg, "");
            let arr = []
            for (let i = 0; i < str.length; i++) {
              if (i % 2 === 1) {
                var obj = {
                  name: str[i - 1] + str[i],
                }
                switch (str[i - 1] + str[i]) {
                  case '旅游':
                    obj.color = 'blue'
                    break
                  case '商务':
                    obj.color = 'green'
                    break
                  case '探访':
                    obj.color = 'cyan'
                    break
                  case '留学':
                    obj.color = 'pink'
                    break
                  case '工作':
                    obj.color = 'orange'
                    break
                }
                arr.push(obj)
              }
            }
            data.entity.Reason = arr
            this.Detail = data
            this.information.alllist = data.alllist
            this.information.worklist = data.worklist
            this.information.finishlist = data.finishlist
            this.information.studentlist = data.studentlist
            this.information.student2list = data.student2list
            this.information.childlist = data.childlist
            this.information.freelist = data.freelist

            if (data.alllist.length > 0) {
              this.infoName = 'alllist'
            } else if (data.worklist.length > 0) {
              this.infoName = 'worklist'
            } else if (data.finishlist.length > 0) {
              this.infoName = 'finishlist'
            } else if (data.studentlist.length > 0) {
              this.infoName = 'studentlist'
            } else if (data.student2list.length > 0) {
              this.infoName = 'student2list'
            } else if (data.childlist.length > 0) {
              this.infoName = 'childlist'
            } else if (data.freelist.length > 0) {
              this.infoName = 'freelist'
            }
            // debugger
            let dc = []
            let array = []
            for (let key in this.information) {
              console.log(key, this.information[key]);
              if (this.information[key] && this.information[key].length > 0) {
                array = [...array, ...this.information[key]]
              }
            }
            array.forEach((item) => {
              for (let i = 0; i < item.vds.length; i++) {
                if (item.vds[i].dc != null) {
                  dc = [...dc, ...item.vds[i].dc]
                }
              }
            })
            this.dc = [...this.dc, ...dc]
            this.noDetail = true
          } else {
            this.Detail = null
            this.noDetail = false
            this.dc = []
            this.infoName = ''
            for (let key in this.information) {
              this.information[key] = []
            }
          }
          this.loading = false
        }).catch(err => {
          this.Detail = null
          this.noDetail = false
          this.dc = []
          this.infoName = ''
          for (let key in this.information) {
            this.information[key] = []
          }
          this.loading = false
        })
      },

      // 点击列表
      changeVisaList(index) {
        this.visaIndex = index
        // 发送请求
        this.GetDetail(this.visaList[index].Id)
      },

      // 详情列表下载
      downLoad(type, id) {
        if (type == 'PDF') {
          this.ExportPdfDetail(id)
        } else if (type == 'WORD') {
          this.ExportWordDetail(id)
        } else if (type == 'dc') {
          window.open(
            this.http + id
          )
        }
      },
      showdetail(item) {
        console.log(item, 'item')
        if (item.entity.PriceDesc) {
          this.$alert(item.entity.PriceDesc, {
            dangerouslyUseHTMLString: true
          });
        }
      },
      // pdf下载
      ExportPdfDetail(id) {
        this.$message({
          message: '正在下载中',
          type: 'warning'
        });
        this.downLoadPDF = true;
        this.$api.ExportPdfDetail({
          VisaId: id,
          FileName: this.infoName
        }).then(res => {
          this.downLoadPDF = false;
          let {
            data,
            result
          } = res.data;
          if (result) {
            this.$message({
              message: '下载成功',
              type: 'success'
            });
            window.open(
              this.http + data
            )
          } else {
            this.$message({
              message: '下载失败，请联系客服',
              type: 'error'
            });

          }
        }).catch(err => {
          this.downLoadPDF = false;
          this.$message({
            message: '下载失败，请联系客服',
            type: 'error'
          });
        })
      },

      // word下载
      ExportWordDetail(id) {
        this.$message({
          message: '正在下载中',
          type: 'warning'
        });
        this.downLoadWORD = true;
        this.$api.ExportWordDetail({
          VisaId: id,
          filename: this.infoName
        }).then(res => {
          this.downLoadWORD = false;
          let {
            data,
            result
          } = res.data;
          if (result) {
            this.$message({
              message: '下载成功',
              type: 'success'
            });
            window.open(
              this.http + data
            )

          } else {
            this.$message({
              message: '下载失败，请联系客服',
              type: 'error'
            });
          }
        }).catch(err => {
          this.downLoadWORD = false;
          this.$message({
            message: '下载失败，请联系客服',
            type: 'error'
          });
        })
      },
    },

  }

</script>
<style lang='less' scoped>
  .page {
    width: 100%;

    .head {
      width: 100%;
      height: 17.5rem;
    }

    .main {
			width: 75rem;
			/* width: 1200px; */
			min-height: 59.875rem;
      padding: 1.375rem 0;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;

      .blue {
        background-color: #68a4e8;
      }

      .green {
        background-color: #46c1a9;
      }

      .pink {
        background-color: #ed83c3;
      }

      .orange {
        background-color: #fa965a;
      }

      .cyan {
        background-color: #52beec;
      }

      .main_left {
        width: 20.625rem;
        height: auto;

        .search {
          width: 100%;
          height: 5.5rem;
          background-color: #599fff;
          position: relative;

          /deep/ .el-autocomplete {
            width: 80%;
            height: 3.25rem;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }

          /deep/ .el-input {
            width: 100% !important;
            height: 100% !important;
          }

          /deep/ .el-input__inner {
            height: 100% !important;
            border: none !important;
            border-color: rgba(0, 0, 0, ) !important;
            font-size: 1rem !important;
          }

          /deep/ .el-input__inner::placeholder {
            font-size: 1rem !important;
          }

          /deep/ .el-input__inner:focus {
            border: none !important;
            border-color: rgba(0, 0, 0, ) !important;
          }

          /deep/ .el-input__suffix-inner {
            position: absolute;
            top: 50%;
            right: 10%;
            transform: translate(0%, -50%);
            margin-right: 1.25rem;
          }

        }

        .main_County {
          padding-left: 1.25rem;
          height: 4rem;
          background-color: #fff;
          display: flex;
          align-items: center;
          font-size: 1rem;

          .el-icon-caret-bottom {
            color: #599fff;
            margin-right: 0.625rem;
          }

          .el-divider--vertical {
            margin: 0 1.25rem;
          }

          .el-image {
            width: 0.625rem;
            height: 0.875rem;
            margin-right: 0.625rem;
          }

          &>div {
            display: flex;
            align-items: center;



            span {
              margin-right: 0.625rem;
            }
          }



        }

        .main_list {
          width: 100%;
          background-color: #fff;

          /deep/ .el-tabs__item {
            padding: 0 0.625rem;
            font-size: 1rem;
          }

          /deep/ .is-active {
            color: #4c92f2 !important;
          }

          /deep/ .el-tabs__nav {
            width: 100%;
            background-color: #fff;
          }

          /deep/ .el-tabs__active-bar {
            width: 1.8125rem;
            background-color: #4c92f2;
          }

          /deep/ .el-tabs__item:hover {
            color: #000000;
          }

          .list {
            width: 100%;
            padding: 1.25rem 0.75rem;
            box-sizing: border-box;
            background-color: #fff;
            font-size: 1rem;
            text-align: left;
            line-height: 1.8rem;
            border-top: 1px solid #eeeeee;
            position: relative;

            .list_title {

              &>span:nth-child(2) {
                font-weight: 600;
                vertical-align: top;
              }

              &>span:nth-child(1) {
                font-size: 0.75rem;
                padding: 0.25rem;
                color: #fff;
                vertical-align: top;
              }


            }

            .list_tips {
              font-size: 0.75rem;
              color: #999999;
              margin-top: 1.25rem;
              display: flex;
              align-items: center;

              &>span:nth-child(1) {
                margin-right: 1.25rem;
                display: flex;
                align-items: center;

                .el-icon-time {
                  vertical-align: middle;
                  font-size: 0.875rem;
                }
              }

              &>span:nth-child(2) {
                white-space: nowrap;
              }

              &>span:nth-child(3) {
                color: #ff8033;
                font-weight: 600;
                margin-left: auto;

              }
            }
          }

          .list_active {
            background-color: #ebf3ff;

            .list_tips {
              color: #000 !important;
            }
          }

          .list_active:before {
            content: "";
            display: block;
            width: 0.1875rem;
            height: 100%;
            background-color: #599fff;
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }

      .main_right {
        width: 53rem;
        height: auto;

        &>div {
          background-color: #fff;
          padding: 1.25rem;
          margin-bottom: 1.25rem;
        }

        .basic_info {
          .main_title {
            font-size: 1.375rem;
            text-align: left;
            font-weight: 600;
          }

          .main_tabs {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 0.9375rem 0 1.25rem;

            &>span {
              font-size: 0.75rem;
              padding: 0.25rem;
              color: #fff;
              margin-right: 0.625rem;
            }
          }

          .main_term {
            width: 100%;
            height: 2.5rem;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            position: relative;

            &>.main_term_item:nth-child(8) {
              position: absolute;
              right: 0.125rem;
              /* right: 6.125rem; */
            }

            .main_term_item {
              text-align: left;

              .main_term_price {

                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
                color: #ff8033;

                /* width: 425%; */
                &>span:nth-child(1) {
                  font-size: 1.375rem;
                  font-weight: 600;
                  margin-left: -0.325rem;
                }

                &>span:nth-child(2) {
                  font-size: 0.75rem;
                }
              }

              &>div:nth-child(1) {
                white-space: nowrap;
                text-align: left;
              }
            }

            &>div {
              height: 2.5rem;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-between;

              &>div:nth-child(1) {
                font-size: 0.75rem;
                color: #999999;
              }

              &>div:nth-child(2) {
                font-size: 0.875rem;
                color: #000000;
              }
            }

            /deep/ .el-divider--vertical {
              margin: 0 2.9375rem;
            }
          }

          .main_detail {
            width: 100%;
            min-height: 2.8125rem;
            display: flex;
            /* align-items: center; */
            justify-content: space-between;
            margin: 2.1875rem 0 1rem;

            .main_term_item {
              text-align: left;

              min-height: 2.2rem;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-between;

              &>div:nth-child(1) {
                font-size: 0.75rem;
                color: #999999;
              }

              &>div:nth-child(2) {
                font-size: 0.875rem;
                color: #000000;
              }

              &>div:nth-child(1) {
                white-space: nowrap;
                text-align: left;
              }
            }

            .el-button {
              background-color: #599fff !important;
              border-color: #599fff !important;
              padding-left: 2.625rem;
              padding-right: 2.625rem;
              margin: 0.25rem;
              font-size: 1rem;
              height: 2.625rem;
            }
          }

          .main_tips {
            border: 1px solid #dbeaff;
            padding: 0.625rem 1.25rem 0rem;

            .main_tips_title {
              font-size: 1rem;
              font-weight: 600;
              text-align: left;
              margin-bottom: 0.625rem;
            }

            /deep/ .main_tips_box {
              font-size: 0.875rem;

              ul {
                list-style: none;
                margin: 0;
                padding: 0;
              }

              p {
                text-align: left;
                margin: 0;
                padding: 0;
                margin-bottom: 0.625rem;
              }

              li {
                text-align: left;
                margin: 0;
                padding: 0;
                margin-bottom: 0.625rem;
              }
            }

          }
        }

        .file_Download {
          padding: 1.25rem 1.25rem 0;

          .file_tiele {
            font-size: 1.25rem;
            font-weight: 600;
            float: left;
            position: relative;
            display: inline-block;
            z-index: 10;
            margin-bottom: 1.25rem;
          }

          .file_tiele:before {
            content: "";
            display: block;
            width: 100%;
            background: linear-gradient(90deg, rgba(90, 153, 255, 1.0), rgba(255, 255, 255, .5));
            height: 0.375rem;
            position: absolute;
            bottom: 0;
            z-index: -1;
            border-radius: 12px;
          }

          .file_item {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            cursor: pointer;

            .item {
              margin-right: 6.25rem;
              margin-bottom: 1.25rem;
              width: 10rem;
              text-align: left;
            }
          }
        }

        .information {
          position: relative;

          .info_tiele {
            font-size: 1.25rem;
            font-weight: 600;
            float: left;
            position: relative;
            display: inline-block;
            z-index: 10;
            margin-bottom: 1.25rem;
          }

          .info_tiele:before {
            content: "";
            display: block;
            width: 100%;
            background: linear-gradient(90deg, rgba(90, 153, 255, 1.0), rgba(255, 255, 255, .5));
            height: 0.375rem;
            position: absolute;
            bottom: 0;
            z-index: -1;
            border-radius: 12px;
          }

          .info_download {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: absolute;
            right: 1.25rem;
            top: 1.25rem;

            .el-button:nth-child(2) {
              background-color: #599fff !important;
              border-color: #599fff !important;
              padding: 0.625rem;
              margin: 0.25rem;
              font-size: 0.75rem;
            }

            .el-button:nth-child(1) {
              background-color: #fff;
              border-color: #599fff !important;
              margin: 0.25rem;
              font-size: 0.75rem;
              color: #599fff !important;
              padding: 0.625rem;
            }
          }

          /deep/ .el-tabs__item {
            padding: 0 1.625rem;
            color: #599fff !important;
          }

          /deep/ .el-tabs__active-bar {
            height: 0.1875rem;
            background-color: #599fff !important;

          }

          /deep/ .el-tabs__item:hover {
            color: #000000 !important;
          }

          /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2),
          .el-tabs--top .el-tabs__item.is-bottom:nth-child(2),
          .el-tabs--bottom .el-tabs__item.is-top:nth-child(2),
          .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2) {
            padding-left: 0 !important;
          }

          .info_main {
            padding: 1.875rem;

            .info_main_title {
              font-size: 1rem;
              font-weight: 600;
              padding-bottom: 0.75rem;
              border-bottom: 1px solid #eeeeee;
              text-align: left;

              &>div {
                display: inline-block;
                position: relative;
              }

              &>div::before {
                content: "";
                display: block;
                width: 100%;
                height: 0.1875rem;
                background-color: #599fff;
                position: absolute;
                bottom: -0.75rem;
              }
            }

            .info_main_box {
              display: flex;
              justify-content: space-between;
              margin-top: 0.625rem;

              .info_main_left {
                width: 11.875rem;
                text-align: left;
                font-size: 0.875rem;

                .IsNeed {
                  color: #ff7f7f;
                }
              }

              /deep/ .info_main_right {
                width: 35.3125rem;
                border-bottom: 1px solid #eeeeee;
                font-size: 0.875rem;
                text-align: left;

                ul {
                  list-style: none;
                  margin: 0;
                  padding: 0;
                }

                p {
                  text-align: left;
                  margin: 0;
                  padding: 0;
                  margin-bottom: 0.625rem;
                }

                li {
                  text-align: left;
                  margin: 0;
                  padding: 0;
                  margin-bottom: 0.625rem;
                }
              }
            }
          }
        }


        .knowledge {
          .knowledge_tiele {
            font-size: 1.25rem;
            font-weight: 600;
            float: left;
            position: relative;
            display: inline-block;
            z-index: 10;
            margin-bottom: 1.25rem;
          }

          .knowledge_tiele:before {
            content: "";
            display: block;
            width: 100%;
            background: linear-gradient(90deg, rgba(90, 153, 255, 1.0), rgba(255, 255, 255, .5));
            height: 0.375rem;
            position: absolute;
            bottom: 0;
            z-index: -1;
            border-radius: 12px;
          }
        }


      }
    }


  }

  .province_item {
    width: 3rem;
    height: 1.35rem;
    /* border: 1px solid #599fff; */
    background-color: #fcfcfc;
    color: rgb(151, 151, 151);
    border: rgb(151, 151, 151) 1px solid;
    margin-bottom: 0.425rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    margin-left: 0.2rem;
  }

  .province_box {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
  }

</style>

<style>
  .el-popovers {
    left: 22.4375rem !important;
  }

</style>



// WEBPACK FOOTER //
// src/page/product/detail.vue